import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import CategoryTable from './CategoryTable';
import { getMenuDetails, updateMenuDetails } from '../api/apiService';
import Header from "./Header"; // Import the Header component

// const storeId = '065896b1-9b82-415c-a178-46273b642374';
// Declare storeId at the top to make it accessible throughout the component
const storeId = localStorage.getItem("storeId");

const CategoryPage = () => {
  const [menuData, setMenuData] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!storeId) {
      alert("Store ID not found. Redirecting to login.");
      navigate("/");
      return;
    }
    fetchMenuData();
  }, []);
  const fetchMenuData = async () => {
    
    try {
      const data = await getMenuDetails(storeId);
      setMenuData(data);
      setMessage('Menu loaded successfully!');
    } catch (error) {
      setMessage(`Error loading menu: ${error.message}`);
    }
  };

  const updateMenu = async (updatedMenuData) => {
    try {
      await updateMenuDetails(storeId, updatedMenuData);
      setMessage('Menu updated successfully!');
      await fetchMenuData(); // Re-fetch to get updated data from DB
    } catch (error) {
      setMessage(`Error updating menu: ${error.message}`);
    }
  };

  const handleEditCategory = async (updatedCategory) => {
    const updatedCategories = menuData.categories.map((cat) =>
      cat.id === updatedCategory.id ? updatedCategory : cat
    );

    const updatedMenu = {
      ...menuData.menus[0],
      category_ids: updatedCategories.map((cat) => cat.id),
    };

    const updatedMenuData = {
      ...menuData,
      categories: updatedCategories,
      menus: [updatedMenu],
    };

    setMenuData(updatedMenuData);
    await updateMenu(updatedMenuData); // Update database via API
  };

  const handleAddCategory = async (newCategory) => {
    const newCategoryObject = {
      id: newCategory.id,
      title: { translations: { en_us: newCategory.title } },
      entities: [],
    };

    const updatedCategories = [...menuData.categories, newCategoryObject];
    const updatedMenu = {
      ...menuData.menus[0],
      category_ids: updatedCategories.map((cat) => cat.id),
    };

    const updatedMenuData = {
      ...menuData,
      categories: updatedCategories,
      menus: [updatedMenu],
    };

    setMenuData(updatedMenuData);
    await updateMenu(updatedMenuData);
  };

  const handleDeleteCategory = async (categoryId) => {
    const updatedCategories = menuData.categories.filter((cat) => cat.id !== categoryId);
    const updatedMenu = {
      ...menuData.menus[0],
      category_ids: updatedCategories.map((cat) => cat.id),
    };

    const updatedMenuData = {
      ...menuData,
      categories: updatedCategories,
      menus: [updatedMenu],
    };

    setMenuData(updatedMenuData);
    await updateMenu(updatedMenuData);
  };

  

  return (
    <div>
      <Header />
      {/* <h2>Categories</h2> */}
      {/* {message && <p style={{ color: message.includes('Error') ? 'red' : 'green' }}>{message}</p>} */}
      {menuData ? (
        <CategoryTable
          categories={menuData.categories}
          onEdit={handleEditCategory}
          onAdd={handleAddCategory}
          onDelete={handleDeleteCategory}
        />
      ) : (
        <p>Loading menu...</p>
      )}
    </div>
  );
};

export default CategoryPage;
